import React from 'react';
import PropTypes from 'prop-types';

const Hamburger = ({
  active = false,
  type = 'boring',
  onClick,
  className = '',
  ...props
}) => {
  const classes = `hamburger hamburger--${type} ${active ? 'is-active' : ''} ${className}`;

  return (
    <button
      className={classes}
      type="button"
      onClick={onClick}
      {...props}
    >
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </button>
  );
};

Hamburger.propTypes = {
  active: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Hamburger;
